import React from 'react';
import axios from 'axios';
import { getSession } from 'Vulture/Session';
import { broncoURL, commitHash } from 'Vulture/ENV';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import style from './Chonky/ChonkyFileBrowser.module.css';

class CreateFolderModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            folderName: ''
        };
        
        this.handleFolderNameChange = this.handleFolderNameChange.bind(this);
        this.handleCreateFolder = this.handleCreateFolder.bind(this);
    }

    handleFolderNameChange(e) {
        this.setState({ folderName: e.target.value });
    }

    async handleCreateFolder() {
        const { folderName } = this.state;
        const { currentFolderId, refreshFileBrowserData, app, accountUUID } = this.props;

        if (!folderName.trim()) {
            alert('Please enter a folder name');
            return;
        }

        app.setState({ loading: true });
        try {
            const session = getSession();
            const headers = {
                headers: {
                    'X-Auth-Session': session.session,
                    'X-Spark-API-version': commitHash,
                    'Content-Type': 'application/json'
                },
            };

            let url;
            if (currentFolderId === 'root') {
                url = `${broncoURL}/api/folder/1/folder`;
            } else {
                const backendFolderId = currentFolderId.replace('node_', '');
                url = `${broncoURL}/api/folder/${backendFolderId}/folder?account_uuid=${accountUUID}`;
            }

            const response = await axios.post(
                url, 
                { name: folderName }, 
                headers
            );
            
            if (response.status === 200) {
                await refreshFileBrowserData();
                app.closeModal();
                this.setState({ folderName: '' });
            } else {
                throw new Error('Failed to create folder');
            }
        } catch (err) {
            console.error('Create folder error:', err);
            alert(`Error creating folder: ${err.response?.data?.message || err.message}`);
        } finally {
            app.setState({ loading: false });
        }
    }

    render() {
        return (
            <div className={style.chonkyModal}>
                <div className={style.formGroup}>
                    <label>
                        Name
                        <input
                            type="text"
                            value={this.state.folderName}
                            onChange={this.handleFolderNameChange}
                        />  
                    </label>
                </div>

                <button
                    onClick={this.handleCreateFolder}
                    className={`button`}
                >
                    <CustomIcon icon='save' /> Save
                </button>
            </div>
        );
    }
}

export default CreateFolderModal;